'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _connector = require('./connector');

var _webClientMessage = require('./webClientMessage');

var _webClientMessage2 = _interopRequireDefault(_webClientMessage);

var _topicConverter = require('./utils/topicConverter');

var _topicConverter2 = _interopRequireDefault(_topicConverter);

var _cookie = require('./utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _idleTimer = require('./connector/idleTimer');

var _idleTimer2 = _interopRequireDefault(_idleTimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var topicConverter = (0, _topicConverter2.default)();

/**
 * @class DiffusionSession
 */

var DiffusionSession = function () {
    /**
     * Constructor for DiffusionSession
     * @param {Object} customConfig
     * @param {Boolean} [customConfig.debugConnector] Turn on connector trace logging.
     * @param {Function} [customConfig.onCallbackFunction] On connected handler.
     * @param {Function} customConfig.onDataFunction
     * @memberOf DiffusionSession
     */
    function DiffusionSession(customConfig) {
        var _this = this;

        _classCallCheck(this, DiffusionSession);

        this.subscriptions = {};
        this.onData = function (data, topic) {
            var message = (0, _webClientMessage2.default)(data, topicConverter.from(topic));
            customConfig.onDataFunction(message);
        };
        this.subscribe = this.subscribe.bind(this);
        this.unsubscribe = this.unsubscribe.bind(this);
        this.unsubscribeAll = this.unsubscribeAll.bind(this);
        if (customConfig.onCallbackFunction) {
            var connector = (0, _connector.getConnector)();
            connector.on('connected', function () {
                _idleTimer2.default.init(_this, customConfig);
                customConfig.onCallbackFunction(true);
            });
            connector.on('error', function () {
                customConfig.onCallbackFunction(false);
            });
            connector.connect();
        }
        var logLevel = (0, _cookie2.default)('logLevel');
        if (logLevel) {
            (0, _connector.setLogLevel)(logLevel);
        }
        if (customConfig.debugConnector) {
            (0, _connector.setLogLevel)('debug');
        }
    }

    _createClass(DiffusionSession, [{
        key: 'subscribe',
        value: function subscribe(config) {
            var _this2 = this;

            var subscribeTopics = config.topics || [config.topic];
            subscribeTopics.filter(function (topic) {
                return _this2.subscriptions[topic];
            }).forEach(function (topic) {
                _this2.subscriptions[topic].fetch();
            });
            var preparedTopics = subscribeTopics.filter(function (topic) {
                return !_this2.subscriptions[topic];
            }).map(topicConverter.to);
            if (preparedTopics.length) {
                (0, _connector.getConnector)().subscribe(preparedTopics).forEach(function (subscription, index) {
                    var topic = preparedTopics[index];
                    subscription.on('update', _this2.onData);
                    _this2.subscriptions[topic] = subscription;

                    if (_idleTimer2.default.isEnabled) {
                        _idleTimer2.default.activeSubscriptions.set('rp/' + topic, {
                            feed: topic,
                            origin: 'rp',
                            onUpdate: _this2.onData
                        });
                    }
                });
            }
        }
    }, {
        key: 'unsubscribe',
        value: function unsubscribe(config) {
            var _this3 = this;

            var unsubscribeTopics = config.topics || [config.topic];
            unsubscribeTopics.filter(function (topic) {
                return _this3.subscriptions[topic];
            }).forEach(function (topic) {
                if (_idleTimer2.default.isEnabled) {
                    _idleTimer2.default.activeSubscriptions.delete('rp/' + topic);
                }
                var topicSubscription = _this3.subscriptions[topic];
                topicSubscription.close();
                delete _this3.subscriptions[topic];
            });
        }
    }, {
        key: 'unsubscribeAll',
        value: function unsubscribeAll() {
            this.unsubscribe({
                topics: Object.keys(this.subscriptions)
            });
        }
    }, {
        key: 'closeConnection',
        value: function closeConnection() {
            this.unsubscribeAll();
            var connector = (0, _connector.getConnector)();
            if (connector && typeof connector.closeSession === 'function') {
                connector.closeSession();
            } else {
                console.warn('debug: connector does not have closeSession method');
            }
        }
    }]);

    return DiffusionSession;
}();

exports.default = DiffusionSession;


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/DiffusionSession.js
// module id = 689
// module chunks = 1